import React, { useState } from "react";
import { Alert, Button, CircularProgress } from "@mui/material";
import AdminPage from "../components/admin/AdminPage";
import AdminSection from "../components/admin/AdminSection";
import OpportunityFeed from "../components/social/OpportunityFeed";
import SocialComposer from "../components/social/SocialComposer";
import {
  useAdminSocial,
  useAdminSocialPost,
} from "../hooks/useAdminSocial";

const SelectedSocialComposer = ({ postId }) => {
  const { error, isLoading, post, snapshot } = useAdminSocialPost(postId);

  if (isLoading) return <CircularProgress aria-label="Loading composer" />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!post || !snapshot) return null;

  return <SocialComposer post={post} snapshot={snapshot} />;
};

const AdminSocial = () => {
  const [selectedPostId, setSelectedPostId] = useState(null);
  const {
    error,
    isLoading,
    isRefreshing,
    opportunities,
    refreshOpportunities,
    warning,
  } = useAdminSocial();

  return (
    <AdminPage
      title="Social"
      subtitle="Things worth posting from Stats.fan."
      actions={
        <Button
          disabled={isRefreshing}
          onClick={() => refreshOpportunities()}
          variant="contained"
        >
          Refresh
        </Button>
      }
      error={error}
    >
      {warning && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          {warning}
        </Alert>
      )}
      <AdminSection title="Opportunities">
        <OpportunityFeed
          isLoading={isLoading}
          onPostCreated={setSelectedPostId}
          opportunities={opportunities}
        />
      </AdminSection>
      {selectedPostId && (
        <AdminSection title="Post composer">
          <SelectedSocialComposer postId={selectedPostId} />
        </AdminSection>
      )}
    </AdminPage>
  );
};

export default AdminSocial;
